import RegulationAPI from "api/RegulationAPI";
import useFetchData from "hooks/useFetchData";

export default function useRegulation( slug?: string ) {
   return useFetchData({
      APIMethod: RegulationAPI.bySlugForUser,
      params: [ slug ],
      condition: !!slug
   })
}